import React from 'react';
import { ItemNumberValue } from 'components/project/FloorBidderScreen';
import styled from 'styled-components';

const Container = styled.div`
  grid-area: lotNumber;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #931C11;
  & h1 {
    margin: 0;
    color: #fff;
    font-size: min(7vw, 8em);
  }
`;

const ItemNumberContainer = () => {
  return (
    <Container>
      <ItemNumberValue />
    </Container>
  );
};

export default ItemNumberContainer;
